import { IncomingConsultation } from 'types';
import { GetIncomingConsultationsResponse } from 'api';

const MOCK_TRAFFIC_DATA: IncomingConsultation[] = [
  {
    dateCreated: new Date(),
    dateReceived: new Date(),
    documentCount: 2,
    id: 519,
    incomingStatus: 'Created',
    incomingStatusId: 1,
    messageId: '4da4eb93-07b7-4017-b227-bdbc158117c5',
    newOrUpdate: 'N',
    planningApplicationReferenceNo: 'Ref/Inbound/Test1',
  },
  {
    dateCreated: new Date(),
    dateReceived: new Date(),
    documentCount: 1,
    id: 520,
    incomingStatus: 'Processed',
    incomingStatusId: 2,
    messageId: '4da4eb93-07b7-4017-b227-bdbc158117c5',
    newOrUpdate: 'U',
    planningApplicationReferenceNo: 'Ref/Inbound/Test2',
  },
  {
    dateCreated: new Date(),
    dateReceived: new Date(),
    documentCount: 4,
    id: 521,
    incomingStatus: 'Error',
    incomingStatusId: 3,
    messageId: '4da4eb93-07b7-4017-b227-bdbc158117c5',
    newOrUpdate: 'N',
    planningApplicationReferenceNo: 'Ref/Inbound/Test3',
  },
  {
    dateCreated: new Date(),
    dateReceived: new Date(),
    documentCount: 5,
    id: 522,
    incomingStatus: 'Error',
    incomingStatusId: 3,
    messageId: '4da4eb93-07b7-4017-b227-bdbc158117c5',
    newOrUpdate: 'N',
    planningApplicationReferenceNo: 'Ref/Inbound/Test4',
  },
  {
    dateCreated: new Date(),
    dateReceived: new Date(),
    documentCount: 2,
    id: 523,
    incomingStatus: 'Created',
    incomingStatusId: 1,
    messageId: '4da4eb93-07b7-4017-b227-bdbc158117c5',
    newOrUpdate: 'U',
    planningApplicationReferenceNo: 'Ref/Inbound/Test5',
  },
  {
    dateCreated: new Date(),
    dateReceived: new Date(),
    documentCount: 0,
    id: 524,
    incomingStatus: 'Created',
    incomingStatusId: 1,
    messageId: '4da4eb93-07b7-4017-b227-bdbc158117c5',
    newOrUpdate: 'U',
    planningApplicationReferenceNo: 'Ref/Inbound/Test6',
  },
  {
    dateCreated: new Date(),
    dateReceived: new Date(),
    documentCount: 0,
    id: 525,
    incomingStatus: 'Error',
    incomingStatusId: 3,
    messageId: '4da4eb93-07b7-4017-b227-bdbc158117c5',
    newOrUpdate: 'U',
    planningApplicationReferenceNo: 'Ref/Inbound/Test7',
  },
  {
    dateCreated: new Date(),
    dateReceived: new Date(),
    documentCount: 3,
    id: 526,
    incomingStatus: 'Created',
    incomingStatusId: 1,
    messageId: '4da4eb93-07b7-4017-b227-bdbc158117c5',
    newOrUpdate: 'N',
    planningApplicationReferenceNo: 'Ref/Inbound/Test8',
  },
  {
    dateCreated: new Date(),
    dateReceived: new Date(),
    documentCount: 8,
    id: 527,
    incomingStatus: 'Created',
    incomingStatusId: 1,
    messageId: '4da4eb93-07b7-4017-b227-bdbc158117c5',
    newOrUpdate: 'N',
    planningApplicationReferenceNo: 'Ref/Inbound/Test9',
  },
  {
    dateCreated: new Date(),
    dateReceived: new Date(),
    documentCount: 6,
    id: 528,
    incomingStatus: 'Processed',
    incomingStatusId: 2,
    messageId: '4da4eb93-07b7-4017-b227-bdbc158117c5',
    newOrUpdate: 'N',
    planningApplicationReferenceNo: 'Ref/Inbound/Test10',
  },
  {
    dateCreated: new Date(),
    dateReceived: new Date(),
    documentCount: 2,
    id: 529,
    incomingStatus: 'Processed',
    incomingStatusId: 2,
    messageId: '4da4eb93-07b7-4017-b227-bdbc158117c5',
    newOrUpdate: 'U',
    planningApplicationReferenceNo: 'Ref/Inbound/Test11',
  },
];

const paginationInfo = {
  currentPage: 1,
  pageSize: 10,
  totalCount: 11,
  totalPages: 2,
};

export const MOCK_INCOMING_CONSULTATIONS_RESPONSE: GetIncomingConsultationsResponse = {
  paginationInfo,
  incomingConsultations: {
    items: MOCK_TRAFFIC_DATA,
  },
};
